import MeetupPage from '@/pages/meetup/MeetupPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/meetup')({
  component: RouteComponent,
});

function RouteComponent() {
  return <MeetupPage />;
}
